import _ from 'lodash';
import { useMemo } from 'react';
import { useGetPartRuleSetsQuery } from 'store/slices/apiV1/inventory';
import { Org } from 'types/org';
import { PartRuleSet } from 'types/partRules';

export default function usePartRuleSets({
  partRuleSetId,
  orgId,
}: {
  partRuleSetId?: PartRuleSet['id'] | null;
  orgId?: Org['id'] | null;
}) {
  const { data: partRuleSets = [], isFetching } = useGetPartRuleSetsQuery();

  const partRuleSet = useMemo(() => {
    if (partRuleSetId) {
      return _.find(partRuleSets, { id: partRuleSetId }) as
        | PartRuleSet
        | undefined;
    }
    if (orgId) {
      return _.find(partRuleSets, { org: orgId }) as PartRuleSet | undefined;
    }
    return _.find(partRuleSets, { defaultRuleSet: true }) as
      | PartRuleSet
      | undefined;
  }, [partRuleSetId, partRuleSets, orgId]);

  return {
    isFetching,
    partRuleSet,
    partRuleSets,
  };
}
